import { Shipment } from '../../../api/orders/shipment/shipmentTypes';

export type Status = 'loading' | 'ready';

export interface State {
  status: Status;
  shipments: Shipment[];
}

type ShipmentsLoadingAction = { type: 'shipments/loading' };
type ShipmentsLoadedAction = { type: 'shipments/loaded', payload: Shipment[] };
type ShipmentsFailedAction = { type: 'shipments/failed' };

export type Action = ShipmentsLoadingAction
| ShipmentsLoadedAction
| ShipmentsFailedAction;

export const initialState: State = {
  status: 'loading',
  shipments: [],
};

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'shipments/loading': {
      return { ...state, status: 'loading' };
    }
    case 'shipments/loaded': {
      return { ...state, status: 'ready', shipments: action.payload };
    }
    case 'shipments/failed': {
      return { ...state, status: 'ready', shipments: [] };
    }
    default:
      return state;
  }
}
